/**
 * @namespace geo.event.svg
 */

/**
 * @event geo.event.svg.rescale
 * @type {geo.event.base}
 * @property {number} scale The scale as a ratio of the original render size.
 */
module.exports = 'geo_svg_rescale';
